import MainRoot from "./main-root";

export default MainRoot;